import { ImageTypes } from "~enums/imageTypes";
import type { Entity } from "~types/entity";

type Props = {
  entity: Pick<Entity, "images" | "nameFullLocal">;
};

import { findImageByType } from "~utilities/findImageByType";

const EntityColumn = ({ entity }: Props) => {
  const entityLogoUrl = findImageByType(entity?.images, ImageTypes.Logo) || findImageByType(entity?.images, ImageTypes.LogoAlternate);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
      {entity &&
        (entityLogoUrl ? (
          <img alt="Team logo" src={entityLogoUrl} width={25} height={25} />
        ) : (
          <i style={{ width: 25 }} className="fas fa-shield fa-xl" />
        ))}
      <span>{entity?.nameFullLocal}</span>
    </div>
  );
};
export default EntityColumn;
